import React from 'react'
import { AmpIFrame } from '../../../publication/Embed/amp/AmpIFrame'
import { StyledContent } from '../../../publication/Embed/amp/AmpStyledContent.styled'

export interface AmpSlidoProps {
    frameborder: 0 | 1
    height: number
    link: string
}

export const AmpSlido: React.FC<AmpSlidoProps> = (props) => (
    <StyledContent>
        <AmpIFrame
            width={undefined}
            height={props.height}
            src={props.link}
            frameborder={props.frameborder}
            layout={'fixed-height'}
            allowSameOrigin={true}
            allowPopups={true}
            allowForms={false}
        />
    </StyledContent>
)
